module.exports = __webpack_public_path__ + "img/花蓮縣.67292194.png";